import auth from './auth'
import fans from './fans'
import menu from './menu'
import keywords from './keywords'
import replys from './replys'
import material from './material'
import mass from './mass'
export default {
	auth,
	fans,
	menu,
	keywords,
	replys,
	material,
	mass
}



// WEBPACK FOOTER //
// ./src/store/mp/wechat/index.js